import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import useViewPort from "../../../../hook/useViewPort";
import { collectionToStories } from "@quintype/components";
import { CollectionName } from "../../Atoms/CollectionName";
import { CollectionHeroImage } from "../../Atoms/CollectionHeroImage";
import ImageType4 from "../../../../components/molecules/image-type-4";
import "./one-row-five-cols-vertical.m.css";

const OneRowFiveColsVertical = ({ collection, config }) => {
  const showSection = get(collection, ["associated-metadata", "show-section-title"], true);
  const showSectionHero = get(collection, ["associated-metadata", "show-section-hero-image"], false);
  const bgColor = get(collection, ["associated-metadata", "Type a number from 1-14 for layout background colors"]) || 1;
  const validNumber = bgColor >= 1 && bgColor <= 14 ? bgColor : 1;
  const colorClass = `color-black-${validNumber}`;
  const storiesFromCollection = collectionToStories(collection);
  const { viewports } = useViewPort();
  if (storiesFromCollection.length < 1) {
    return null;
  }
  return (
    <div styleName={`container ${colorClass}`}>
      {showSectionHero&&<CollectionHeroImage config={config} collection={collection} />}
      <div styleName="collection-name"  className={viewports?viewports:""}>
        <CollectionName collection={collection} />
        <i class="ri-arrow-right-line"></i>
      </div>
      <div styleName="image-grid"  className={viewports?viewports:""}>
        {storiesFromCollection.map((storyItem) => (
          <div id={storyItem.id} styleName="image-container" className={viewports?viewports:""}>
            <ImageType4 story={storyItem} aspectRatio={[[9, 16]]} showOverlay />
          </div>
        ))}
      </div>
    </div>
  );
};

OneRowFiveColsVertical.propTypes = {
  collection: object,
};
export { OneRowFiveColsVertical };

OneRowFiveColsVertical.storyLimit = 22;
